// PrimeVue setup: the design-system theme plus every globally registered PrimeVue component,
// service and directive. The theme itself is not defined here — the preset lives in
// ./preset.js, the single place for PrimeVue theme overrides (see design_system/AGENTS.md).
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import Ripple from 'primevue/ripple';
import Tooltip from 'primevue/tooltip';

import Accordion from 'primevue/accordion';
import AccordionContent from 'primevue/accordioncontent';
import AccordionHeader from 'primevue/accordionheader';
import AccordionPanel from 'primevue/accordionpanel';
import Badge from 'primevue/badge';
import Button from 'primevue/button';
import Card from 'primevue/card';
import CascadeSelect from 'primevue/cascadeselect';
import Chart from 'primevue/chart';
import Checkbox from 'primevue/checkbox';
import ColorPicker from 'primevue/colorpicker';
import Column from 'primevue/column';
import DataTable from 'primevue/datatable';
import DatePicker from 'primevue/datepicker';
import Dialog from 'primevue/dialog';
import Divider from 'primevue/divider';
import Drawer from 'primevue/drawer';
import Dropdown from 'primevue/dropdown';
import IconField from 'primevue/iconfield';
import InputGroup from 'primevue/inputgroup';
import InputGroupAddon from 'primevue/inputgroupaddon';
import InputIcon from 'primevue/inputicon';
import InputNumber from 'primevue/inputnumber';
import InputText from 'primevue/inputtext';
import Menu from 'primevue/menu';
import Message from 'primevue/message';
import MultiSelect from 'primevue/multiselect';
import PAvatar from 'primevue/avatar';
import Paginator from 'primevue/paginator';
import PickList from 'primevue/picklist';
import ProgressBar from 'primevue/progressbar';
import ProgressSpinner from 'primevue/progressspinner';
import RadioButton from 'primevue/radiobutton';
import Select from 'primevue/select';
import SelectButton from 'primevue/selectbutton';
import Skeleton from 'primevue/skeleton';
import SplitButton from 'primevue/splitbutton';
import Tag from 'primevue/tag';
import Toast from 'primevue/toast';
import ToggleButton from 'primevue/togglebutton';
import { Chip, ToggleSwitch } from 'primevue';
// Popover, wrapped so opening one closes the others.
import Popover from '@/app/shared_components/SingleOpenPopover.js';
import 'primeicons/primeicons.css';

import preset from '@/plugins/primevue/preset.js';

const components = {
  Accordion,
  AccordionContent,
  AccordionHeader,
  AccordionPanel,
  Badge,
  Card,
  CascadeSelect,
  Chart,
  Checkbox,
  Chip,
  ColorPicker,
  Column,
  DataTable,
  DatePicker,
  Divider,
  Drawer,
  Dropdown,
  IconField,
  InputGroup,
  InputGroupAddon,
  InputIcon,
  InputNumber,
  InputText,
  Message,
  MultiSelect,
  Paginator,
  PAvatar,
  PButton: Button,
  PickList,
  PMenu: Menu,
  Popover,
  PrimeDialog: Dialog,
  ProgressBar,
  ProgressSpinner,
  PSelect: Select,
  RadioButton,
  SelectButton,
  Skeleton,
  SplitButton,
  Tag,
  Toast,
  ToggleButton,
  ToggleSwitch,
};

export default {
  install(app) {
    app.use(PrimeVue, {
      theme: {
        preset,
        options: {
          darkModeSelector: '.dark',
          // Keep PrimeVue's CSS in a layer below Tailwind's utilities, so a utility class can
          // override a component without !important. The order matches assets/css/index.css.
          cssLayer: {
            name: 'primevue',
            order: 'theme, base, buefy, primevue, components, utilities',
          },
        },
      },
    });
    app.use(ToastService);

    for (const [name, component] of Object.entries(components)) {
      app.component(name, component);
    }

    app.directive('ripple', Ripple);
    app.directive('tooltip', Tooltip);
  },
};
